export default __webpack_public_path__ + "static/media/Mr. Kumar Debasish Dash.6572b961.png";